// extracted by mini-css-extract-plugin
module.exports = {"tile":"SettingsRow_tile__1s-iL","ccIcon":"SettingsRow_ccIcon__2l_vH","ccOn":"SettingsRow_ccOn__i6jce","legalHeader":"SettingsRow_legalHeader__1qJmz"};